
import { defineComponent, ref, computed, getCurrentInstance } from 'vue';
import Tree from './docs-main/tree-view/Tree.vue';
import type { RootTree } from '@/templates/Tree';

export default defineComponent({
  name: 'DocsSidebar',
  components: {
    Tree,
  },
  props: {
    minHeight: {
      type: String,
      default: 'auto',
    },
  },
  setup() {
    const instance = getCurrentInstance();
    const store = instance?.proxy?.$store;

    const docsLayoutSidebar = ref<HTMLElement | null>(null);
    const showSidebar = ref(true);

    const treeData = computed<RootTree>(() => store?.getters?.getTree ?? ({} as RootTree));
    const sidebarToggleClass = computed(() => (showSidebar.value ? 'is-collapsed' : 'is-expanded'));

    const toggleSidebar = () => {
      showSidebar.value = !showSidebar.value;
    };

    const enterSidebar = (_element: HTMLElement, done: () => void) => {
      if (docsLayoutSidebar.value) {
        docsLayoutSidebar.value.style.width = '100%';
      }
      done();
    };

    const afterEnterSidebar = () => {
      if (docsLayoutSidebar.value) {
        docsLayoutSidebar.value.style.width = '100%';
      }
    };

    const leaveSidebar = (_elm: HTMLElement, done: () => void) => {
      if (docsLayoutSidebar.value) {
        docsLayoutSidebar.value.style.width = '16px';
      }
      done();
    };

    return {
      docsLayoutSidebar,
      showSidebar,
      treeData,
      sidebarToggleClass,
      toggleSidebar,
      enterSidebar,
      afterEnterSidebar,
      leaveSidebar,
    };
  },
});
